<script>
	import { slugify } from "cando-util";

	export let value;
	export let options;
	export let disabled = false;
	export let disabledClass = "";
	export let tabIndex = 0;
	export let type = "radio";
	export let optionLayout = "horizontal";
	export let optionLabelPos = "left";
	export let label = "";
	export let handleChange = () => {};
	export let labelClass = "text-2xl";
	export let readonly = false;

	let previousValue = "";

	$: optionsAry = options || [];

	const handleRadioChange = (e) => {
		value = e.target.value;
		handleChange(e);
	};

	$: selectedValues = Array.isArray(value) ? value : [];
	$: if (type === "checkbox" && !Array.isArray(value)) {
		value = [];
	} else if (type === "radio" && (value === undefined || value === null)) {
		value = "";
	}
</script>

<div
	class={`${optionLayout === "horizontal" ? "sm:flex gap-2 sm:gap-4 sm:flex-wrap" : ""}`}
>
	{#each optionsAry as option}
		<label
			class={`cursor-pointer label ${optionLabelPos !== "left" ? "justify-start" : ""} block`}
		>
			{#if optionLabelPos === "left"}
				<span class={`label-text mr-2 ${labelClass} ${disabledClass}`}
					>{option?.label || option}</span
				>
			{/if}
			{#if type === "radio"}
				{#if !readonly || value === (option.value || option)}
					<input
						id={`${slugify(label)}-${slugify(option.label || option)}-radio-input`}
						type="radio"
						name={label}
						value={option.value || option}
						tabindex={tabIndex}
						bind:group={value}
						class="radio radio-primary"
						{disabled}
						on:change={handleRadioChange}
					/>
				{:else}
					<div class="radio radio-primary"></div>
				{/if}
			{/if}
			{#if type === "checkbox"}
				{#if !readonly}
					<input
						type="checkbox"
						id={`${slugify(label)}-${slugify(option.label || option)}-checkbox-input`}
						name={label}
						value={option.value || option}
						tabindex={tabIndex}
						bind:group={value}
						class="checkbox checkbox-primary"
						{disabled}
						{readonly}
						on:change={handleChange}
					/>
				{:else if selectedValues.includes(option.value || option)}
					<!-- Checked Display -->
					<div
						class="checkbox checkbox-primary bg-primary flex items-center justify-center"
					>
						<svg
							class="text-primary-content"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M5 13l4 4L19 7"
								stroke="currentColor"
								stroke-width="4"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				{:else}
					<div class="checkbox checkbox-primary"></div>
				{/if}
			{/if}
			{#if type === "presets"}
				<!-- the values here are set to the labels because this is for a text input.  I'd want the soure lang here -->
				{#if !readonly}
					<input
						type="checkbox"
						id={`${slugify(label)}-${slugify(option.label || option)}-presets-input`}
						name={option.label || option}
						tabindex={tabIndex}
						checked={value === (option.label || option)}
						on:change={() => {
							if (value === (option.label || option)) {
								value = previousValue;
							} else {
								previousValue = value || "";
								value = option.label || option;
							}
							handleChange();
						}}
						class="checkbox checkbox-primary"
						disabled={disabled || readonly ? true : false}
					/>
				{:else if value === (option.label || option)}
					<!-- Checked Display -->
					<div
						class="checkbox checkbox-primary bg-primary flex items-center justify-center"
					>
						<svg
							class="text-primary-content"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path
								d="M5 13l4 4L19 7"
								stroke="currentColor"
								stroke-width="4"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</div>
				{:else}
					<div class="checkbox checkbox-primary"></div>
				{/if}
			{/if}
			{#if optionLabelPos !== "left"}
				<span
					class={`label-text ml-2 text-left ${labelClass} ${disabledClass}`}
					>{option.label || option}</span
				>
			{/if}
		</label>
	{/each}
</div>
